import ServiceTemplate from './service-page-template/service-page-template.jsx';
import { imagesMetadata } from '../../imagesMetadata.js';

const heroImageSrc = '/static/images/gardening-melbourne.webp';
const heroMeta = imagesMetadata[heroImageSrc];

const excludedImages = [
  heroImageSrc,
  // Add any other image paths to exclude here...
];

const gardeningGalleryImages = Object.entries(imagesMetadata)
  .filter(([src]) => src.startsWith('/static/images/gardening/') && !excludedImages.includes(src))
  .map(([src, meta], index) => ({
    id: index + 1,
    src,
    alt: meta.alt,
    location: meta.location
  }));

export default function Gardening() {
    const servicesData = {
        title: "Gardening & Garden Maintenance",
        subtitle: "Professional gardening services, lawn care, garden clean-ups and outdoor maintenance across Melbourne.",
        metaTitle: "Gardening & Garden Maintenance Melbourne | Lawn Care",
        metaDesc: "Melbourne garden maintenance for lawn mowing, garden clean-ups, hedge trimming, weeding and outdoor tidy-ups. Book a reliable local gardening service.",
        canonicalPath: "/gardening",

        solutionsTitle: "Our Gardening Services",
        solutionsIntro: "We provide reliable gardening and outdoor maintenance to keep your garden looking neat, healthy, and well-presented all year round.",

        solutionsList: [
            { 
                emoji: "🌱", 
                heading: "Lawn Mowing & Care", 
                text: "Regular mowing, edging, fertilising, and lawn treatments for healthy, lush grass." 
            },
            { 
                emoji: "🍃", 
                heading: "Garden Clean-ups & Tidy-ups", 
                text: "Removal of weeds, leaves, overgrown vegetation, and general garden decluttering." 
            },
            { 
                emoji: "✂️", 
                heading: "Hedge Trimming & Pruning", 
                text: "Professional shaping and maintenance of hedges, shrubs, and small trees." 
            },
            { 
                emoji: "🪴", 
                heading: "Planting & Mulching", 
                text: "New plant installations, mulch application, and basic garden bed preparation." 
            }
        ],

        serviceImage: {
            src: heroImageSrc,
            alt: heroMeta?.alt || 'Professional gardening and lawn maintenance in Melbourne'
        },

        extendedDetails: [
            {
                title: "Reliable & Regular Service",
                body: "Whether it’s a one-off spring clean-up or fortnightly maintenance, we stick to schedules and deliver consistent, high-standard results."
            },
            {
                title: "Thorough & Tidy Work",
                body: "All green waste is removed from site. We leave your garden neat, with clean edges and no clippings scattered across paths or lawns."
            },
            {
                title: "Safe & Professional Equipment",
                body: "We use well-maintained tools and follow proper safety practices, especially when working near homes, fences, and children’s play areas."
            }
        ],

        galleryImages: gardeningGalleryImages,

        faqs: [
            {
                question: 'What outdoor services do you provide?',
                answer: 'Fence repairs, decking, garden tidy-ups, weeding, mulching, and basic landscaping.'
            },
            {
                question: 'Can you repair or install new fences?',
                answer: 'Yes. Timber, colourbond, and retaining walls.'
            },
            {
                question: 'Do you handle garden maintenance?',
                answer: 'Yes — mowing, hedging, weeding, and seasonal clean-ups.'
            },
        ],
    };

    return <ServiceTemplate {...servicesData} />;
}
